import { render, staticRenderFns } from "./NeoparentNewAccess.vue?vue&type=template&id=ea55c76c&scoped=true"
import script from "./NeoparentNewAccess.vue?vue&type=script&lang=js"
export * from "./NeoparentNewAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea55c76c",
  null
  
)

export default component.exports